// CONSTANTS are all caps.
const NS = 'ProductListingPage';
const CLS = 'productListingPage';
const PG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadPg.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import vivalid from 'vivalid';
import * as utils from '../../../../global/js/utils';
import * as Api from '../../../../global/js/api';
import * as Cart from '../../../../global/js/cart';
import {loadQuantityInput} from '../../../widgets/quantityInput/js/loadWg';
import {loadProductsFilters} from '../../../widgets/productsFilters/js/loadWg';
import Handlebars from 'handlebars';
import pagination from 'paginationjs';
import env from '../../../../global/js/env';
import {ifCond, lowerCase} from '../../../../global/helpers/conditions';
import {addSlashToUrl} from '../../../../global/js/utils';

export class ProductListingPage {
	constructor($el) {
		// $el is the page node return by the loadProductListingPage function
		this.$el = $el;
	}

	init() {
		addSlashToUrl();
		this.firstLoad = true;
		this.path = (env == 'prod') ? '/static/assets' : '../../assets';
		this.selectedFilters = {};
		this.initHbsPartials();
		this.setProductListingPage();
		this.handleQuickView();
	}

	setProductListingPage() {
		// Add Some logic here
		const $pg = $(this.$el);
		let This = this;
		let $id = $pg.data('id');
		This.currPage = 1;
		This.pageSizes = $pg.data('pageSizes') || [];
		This.pageSizeSelect = $pg.find('.page-size');
		This.defaultPageSize = $pg.data('defaultPageSize');
		This.$filtersWrapper = $pg.find(PG + 'filters');

		This.pageSize = This.defaultPageSize;

		// Preset the filters and fetch results
		let $queryString = window.location.hash;

		This.selectedFilters = {
			id: $id,
			term: '',
			group: '',
			filters: [],
			page: This.currPage,
			pageSize: This.pageSize,
		};

		if ($queryString != '' && $queryString != '#?') {
			// format the filters array
			// tick all checkboxes for selected filters
			This.selectedFilters.filters = This.queryStringToArray($queryString);
			This.selectedFilters.term = This.queryStringToTerm($queryString);
			This.checkBoxesInit(This.selectedFilters.filters);
			This.currPage = This.queryStringToPage($queryString) || 1;
			This.selectedFilters.page = This.currPage;
			This.pageSize = This.queryStringToPageSize($queryString) || This.defaultPageSize;
		}

		if (This.pageSizes && This.pageSizes.length) {
			for (let i = 0; i < This.pageSizes.length; i++) {
				let value = This.pageSizes[i];
				let isCurrent = false;

				if (parseInt(value) === parseInt(This.pageSize)) isCurrent = true;

				This.pageSizeSelect.append(`
					<option value="${value}" ${(isCurrent) ? 'selected="selected"' : ''}>Show: ${value} items</option>
				`);
			}
		}

		This.pageSizeSelect.on('change', function() {
			This.currPage = 1;
			This.selectedFilters.page = 1;
			let value = This.pageSizeSelect.val();

			This.pageSize = value;

			This.fetchResults();
		});

		// fetch results
		This.fetchResults();

		$pg.on('click', '.reset-btn, .mobile-reset', function(e) {
			This.currPage = 1;

			e.preventDefault();

			// uncheck all checkboxes
			This.$filtersWrapper.find('input[type="checkbox"]').each(function() {
				$(this).prop('checked', false);
			});

			let yScroll= document.body.scrollTop;
			window.location.hash = '';
			document.body.scrollTop= yScroll;

			This.selectedFilters = {
				id: $id,
				term: '',
				group: '',
				filters: [],
				page: This.currPage,
			};

			This.fetchResults();

			$pg.find('[data-target="#CourseTypeValuesFilters"]').trigger('click');
		});

		$pg.on('click', '.update-btn', function() {
			This.currPage = 1;

			let queryString = '?';
			This.selectedFilters = {
				id: $id,
				term: '',
				group: '',
				filters: [],
				page: This.currPage,
			};

			// add term
			let $currentQueryString = window.location.hash;
			if ($currentQueryString != '') {
				let $term = This.queryStringToTerm($currentQueryString);
				if ($term != '') {
					queryString = queryString + 'term=' + $term + '&';
					This.selectedFilters.term = $term;
				}
			}

			// add group
			if (typeof $productGrouping !== 'undefined') {
				// BE inlined
				// eslint-disable-next-line no-undef
				This.selectedFilters.group = $productGrouping;
			}

			// add filters
			$pg.find('.filters-group').each(function() {
				let $obj = {
					title: '',
					values: [],
				};

				$obj.title = $(this).data('groupName');
				$obj.values = [];

				let queryValues = '';

				$(this).find('input[type="checkbox"]').each(function() {
					if ($(this).is(':checked')) {
						$obj.values.push($(this).val());
						queryValues = queryValues + $(this).val() + ',';
					}
				});
				if ($obj.values != 0) {
					This.selectedFilters.filters.push($obj);
					// remove , from end of string
					queryValues = queryValues.replace(/,\s*$/, '');
					queryString = queryString + $obj.title + '=' + queryValues + '&';
				}
			});

			// update hash value
			if (queryString == '?') {
				queryString = '';
			}

			queryString = queryString.replace(/&\s*$/, '');
			window.location.hash = queryString;

			// fetch results
			This.fetchResults();
		});

		$pg.on('click', PG + 'viewSwitchers img', function() {
			if ($(this).hasClass('active')) {
				return;
			} else {
				$pg.find(PG + 'viewSwitchers img').toggleClass('active');

				This.fetchResults(false);
			}
		});
	}

	fetchResults(initPaging = true) {
		const This = this;
		const $pg = $(this.$el);
		let $listFiltersEndPoint = $pg.data('listFiltersEndpointApi');

		$pg.find('.products-list-empty').hide();

		if (typeof $productGrouping !== 'undefined') {
			// BE inlined
			// eslint-disable-next-line no-undef
			This.selectedFilters.group = $productGrouping;
		}

		if (!initPaging) {
			This.selectedFilters.page = This.currPage || 1;
		}

		This.selectedFilters.pageSize = This.pageSize;

		// update hash's page number
		if ($pg.find('.pagination').length) window.location.hash = utils.updateURLParameter('page', This.currPage);

		// update hash's page size
		if (This.pageSize) window.location.hash = utils.updateURLParameter('pageSize', This.pageSize);

		if (This.selectedFilters.length != 0) {
			$('.loading-spinner').addClass('is-active');

			fetch($listFiltersEndPoint, {
				method: 'post',
				body: JSON.stringify(This.selectedFilters).replace(/>/g, '&gt;'),
				credentials: 'same-origin',
				headers: new Headers({
					'Content-Type': 'application/json',
				}),
			})
			.then((resp) => resp.json())
			.then(function(data) {
				if (data.result == 'SUCCESS') {
					// edit page to show fetched list
					// remove the existing results
					$pg.find('.products-list').removeClass('row').empty();

					if (data.response && data.response.length > 0) {
						for (let i = 0; i < data.response.length; i++) {
							// check the view mode
							if ($pg.find('.grid-view').hasClass('active')) {
								// if no images or array is empty, set images[0] to no-img.png
								if (!data.response[i].images || data.response[i].images.length === 0) {
									data.response[i].images = [`${This.path}/images/no-img.png`];
								}

								$pg.find('.products-list').append(This.productGridItem(data.response[i]));
							} else {
								$pg.find('.products-list').append(This.productListItem(data.response[i]));
							}

							$pg.find('.products-list').find('.product-item').last().attr('data-line-item-data', JSON.stringify(data.response[i]));
						}

						$pg.find('.products-list').addClass('row');

						// list or grid layout
						if ($pg.find('.grid-view').hasClass('active')) {
							// grid items
							$pg.find('.products-list').find('.product-item').wrap('<div class="col-6 col-lg-4 item grid"></div>');
						} else {
							// list items
							$pg.find('.products-list').find('.product-item').wrap('<div class="col-6 col-lg-12 item"></div>');
						}

						if (initPaging) {
							// destroy any existing paging instance
							if (This.pagingInstance) {
								$pg.find('.pagination').pagination('destroy');
								This.pagingInstance = false;
							}
							// init paging
							This.handlePaging(data.totalPages);
						}
					} else {
						$pg.find('.products-list-empty').show();

						if (This.pagingInstance) {
							$pg.find('.pagination').pagination('destroy');
							This.pagingInstance = false;
						}

						This.pagingInstance = false;

						$('html, body').animate({
							scrollTop: 0,
						}, 250);
					}

					// filters
					// clear filters
					This.$filtersWrapper.html('');
					This.$filtersWrapper.append(This.productsFilters({
						filterGroups: data.filters || [],
						hasFilters: (data.filters && data.filters.length > 0) ? true : false,
					}));

					// init
					loadProductsFilters(This.$filtersWrapper[0]).then((wg) => {
						wg ? wg.init() : '';
					}).catch((error) => error + 'An error occurred while loading the productsFilters widget');
				} else {
					// show error div
					$pg.find('.error-messages').addClass('is-active').text(data.message);
				}

				$pg.find('.productsFilters').removeClass('is-open');
				// toggle spinners
				$('.loading-spinner').removeClass('is-active');

				// scroll to top of the page
				if (!This.firstLoad) {
					$('html, body').animate({
						scrollTop: $pg.position().top,
					}, 250);
				}

				This.firstLoad = false;
			}).catch(function(msg) {
				$pg.find('.productsFilters').removeClass('is-open');
				// show error div
				$pg.find('.error-messages').addClass('is-active').text(msg);
				// toggle spinners
				$('.loading-spinner').removeClass('is-active');
			});
		}
	}

	queryStringToArray($queryString) {
		// slice (2) because we have a hash. If we have only a (?), then we will use slice(1)
		let arrEelemnts = $queryString.slice(2).split('&');
		let filters = [];
		for (let i = 0; i < arrEelemnts.length; i++) {
			let filterObj = {
				title: '',
				values: [],
			};

			let title = arrEelemnts[i].split('=')[0];
			if (title != 'term' && title != 'page' && title != 'pageSize') {
				filterObj.title = arrEelemnts[i].split('=')[0];
				filterObj.values = arrEelemnts[i].split('=')[1].split(',');
				filters.push(filterObj);
			}
		}
		return filters;
	}

	queryStringToPage($queryString) {
		// slice (2) because we have a hash. If we have only a (?), then we will use slice(1)
		let arrEelemnts = $queryString.slice(2).split('&');
		let page = '';

		for (let i = 0; i < arrEelemnts.length; i++) {
			let title = arrEelemnts[i].split('=')[0];

			if (title == 'page') {
				page = arrEelemnts[i].split('=')[1];
				break;
			}
		}

		return page;
	}

	queryStringToPageSize($queryString) {
		const This = this;

		// slice (2) because we have a hash. If we have only a (?), then we will use slice(1)
		let arrEelemnts = $queryString.slice(2).split('&');
		let pageSize = '';

		for (let i = 0; i < arrEelemnts.length; i++) {
			let title = arrEelemnts[i].split('=')[0];

			if (title == 'pageSize') {
				pageSize = arrEelemnts[i].split('=')[1];
				break;
			}
		}

		// check if page size is in the sizes array
		let match = This.pageSizes.find((item) => parseInt(item) === parseInt(pageSize));

		if (match) return pageSize;

		return This.defaultPageSize;
	}

	queryStringToTerm($queryString) {
		// slice (2) because we have a hash. If we have only a (?), then we will use slice(1)
		let arrEelemnts = $queryString.slice(2).split('&');
		let term = '';
		for (let i = 0; i < arrEelemnts.length; i++) {
			let title = arrEelemnts[i].split('=')[0];
			if (title == 'term') {
				term = arrEelemnts[i].split('=')[1];
				break;
			}
		}
		return term;
	}

	checkBoxesInit(filters) {
		let $pg = $(this.$el);

		// uncheck all checkboxes
		$pg.find('.productsFilters input').each(function() {
			$(this).prop('checked', false);
		});

		// check only the boxes with values matching the ones selected from the querystring
		for (let i = 0; i < filters.length; i++) {
			let title = filters[i].title;
			let values = filters[i].values;
			for (let j = 0; j < values.length; j++) {
				$pg.find('.productsFilters [data-group-name="'+ title +'"]')
					.find('input[value="'+ values[j] +'"]').prop('checked', true);
			}
		}
	}

	initHbsPartials() {
		// Require partial
		let productListItem = require('../../../widgets/productListItem/tmpl/productListItem.hbs');
		let productGridItem = require('../../../widgets/productGridItem/tmpl/productGridItem.hbs');
		let quickViewModal = require('../../../widgets/productListItem/tmpl/_quickView.hbs');
		let quickViewWithImageModal = require('../../../widgets/productListItem/tmpl/_quickViewWithImage.hbs');
		let quantityInput = require('../../../widgets/quantityInput/tmpl/quantityInput.hbs');
		let productsFilters = require('../../../widgets/productsFilters/tmpl/productsFilters.hbs');

		Handlebars.registerHelper('ifCond', ifCond);
		Handlebars.registerHelper('lowerCase', lowerCase);
		Handlebars.registerPartial('productListItem', productListItem);
		Handlebars.registerPartial('productGridItem', productGridItem);
		Handlebars.registerPartial('quickViewModal', quickViewModal);
		Handlebars.registerPartial('quickViewWithImageModal', quickViewWithImageModal);
		Handlebars.registerPartial('quantityInput', quantityInput);
		Handlebars.registerPartial('productsFilters', productsFilters);

		let productListItemScript = `
			{{> productListItem
				wg="productListItem"
				ns="ProductListItem"
				mods="product-item"
			}}
		`;

		let productGridItemScript = `
			{{> productGridItem
				wg="productGridItem"
				ns="ProductGridItem"
				mods="is-list-item product-item"
			}}
		`;

		let quickViewModalScript = `
			{{> quickViewModal
				wg="productListItem"
			}}
		`;

		let quickViewWithImageModalScript = `
			{{> quickViewWithImageModal
				wg="productListItem"
			}}
		`;

		let productsFiltersScript = `
			{{> productsFilters
				wg="productsFilters"
				ns="ProductsFilters"
				hasUpdateBtn=true
			}}
		`;

		let productListItemPrecompiled = new Function('return ' + Handlebars.precompile(productListItemScript))();
		let productGridItemPrecompiled = new Function('return ' + Handlebars.precompile(productGridItemScript))();
		let quickViewModalPrecompiled = new Function('return ' + Handlebars.precompile(quickViewModalScript))();
		let quickViewWithImageModalPrecompiled = new Function('return ' + Handlebars.precompile(quickViewWithImageModalScript))();
		let productsFiltersPrecompiled = new Function('return ' + Handlebars.precompile(productsFiltersScript))();

		this.productListItem = Handlebars.template(productListItemPrecompiled);
		this.productGridItem = Handlebars.template(productGridItemPrecompiled);
		this.quickViewModal = Handlebars.template(quickViewModalPrecompiled);
		this.quickViewWithImageModal = Handlebars.template(quickViewWithImageModalPrecompiled);
		this.productsFilters = Handlebars.template(productsFiltersPrecompiled);
	}

	handleQuickView() {
		const $pg = $(this.$el);

		$pg.on('click', '.quick-view-trigger', (e) => {
			let itemData = $(e.currentTarget).closest('.product-item').data('lineItemData');

			$pg.find('.productListItem-modal').remove();

			if (itemData.superClass && itemData.superClass.toLowerCase() === 'charge') {
				$pg.append(this.quickViewModal(itemData));
			} else {
				$pg.append(this.quickViewWithImageModal(itemData));
			}

			$pg.find('.productListItem-modal').modal('show');

			// init qty input
			loadQuantityInput($pg.find('.productListItem-modal')[0]).then((wg) => {
				wg ? wg.init() : '';
			}).catch((error) => error + 'An error occurred while loading the quantityInput widget');

			this.setFormValidation();
		});
	}

	handleAddToCart() {
		const $pg = $(this.$el);
		let endpoint = $pg.data('addToCartEndpointApi');

		const $modal = $pg.find('.productListItem-modal');

		let data = {
			id: $modal.data('id'),
			quantity: $modal.find('.quantityInput input').val(),
			description: $modal.find('[name="description"]').val() || '',
		};

		if (data.description === '') {
			delete(data['description']);
		}

		$modal.find('.success-messages, .error-messages').html('').removeClass('is-active');
		$modal.removeClass('has-status');

		// spinner
		$('.loading-spinner').addClass('is-active');

		// call
		Api.callApi(endpoint, data)
			.then((res) => {
				$modal.addClass('has-status');

				if (res.result == 'SUCCESS') {
					$modal.find('.success-messages').html('Item successfully added to your cart').addClass('is-active');

					// reset fields
					$modal.find('.quantityInput input').val('1');
					// if there is description
					$modal.find('[name="description"]').val('');

					// hide the modal
					$modal.modal('hide');
				} else {
					$modal.find('.error-messages').html(res.message).addClass('is-active');
				}

				// update cart
				Cart.updateCart(res.response.cartSummary);
				$('.loading-spinner').removeClass('is-active');
			})
			.catch((error) => {
				$modal.addClass('has-status');

				$modal.find('.error-messages').html(error).addClass('is-active');
				$('.loading-spinner').removeClass('is-active');
			});
	}

	setFormValidation() {
		utils.formValidationRules();

		let addCallback = vivalid.htmlInterface.addCallback;
		let initAllValidations = vivalid.htmlInterface.initAll;

		if (!this.validationInit) {
			addCallback('onValidationSuccess', () => {
				this.handleAddToCart();
			});

			addCallback('onValidationFailure', (invalid, pending, valid) => {
        let popUpErrorMessage = $('#pop-up-err-msg').val();
        alert(popUpErrorMessage);
      });
		}

		initAllValidations();

		this.validationInit = true;
	}

	handlePaging(pages) {
		const This = this;
		const $pg = $(this.$el);

		if ($pg.find('.pagination').length) {
			$pg.find('.pagination').pagination({
				dataSource: function(done) {
					let res = [];
					for (let i = 1; i <= pages; i++) {
						res.push(i);
					}
					done(res);
				},
				pageSize: 1,
				pageNumber: (This.currPage && This.currPage <= pages) ? This.currPage : 1,
				prevText: '<span class="pagination-prev icon-chevron-left"></span>',
				nextText: '<span class="pagination-next icon-chevron-right"></span>',
				ellipsisText: '...',
				hideWhenLessThanOnePage: true,
				triggerPagingOnInit: false,
				ulClassName: 'pagination',
				callback: function(data, pagination) {
					This.currPage = pagination.pageNumber;
					This.fetchResults(false);
				},
				afterInit: function() {
					This.pagingInstance = true;
				},
			});
		}
	}
	// Add more functions like on above here
}



// WEBPACK FOOTER //
// C:/Users/GavinDow/source/repos/FrontEndWebsite/src/views/pages/productListingPage/js/productListingPage.js